// app/javascript/task_modal.js

document.addEventListener('turbolinks:load', function() {
    const taskModal = document.getElementById('taskModal');
    if (taskModal) {
      taskModal.addEventListener('show.bs.modal', function (event) {
        const link = event.relatedTarget;
        const taskId = link.getAttribute('data-task-id');
        const modalBody = taskModal.querySelector('.modal-body');
        
        // Fetch the task description
        fetch(`/tasks/${taskId}/description`)
          .then(response => response.text())
          .then(html => {
            modalBody.innerHTML = html;
          })
          .catch(error => {
            console.error('Error:', error);
            modalBody.innerHTML = 'Er is een fout opgetreden bij het laden van de taakbeschrijving.';
          });
      });
    }
});